import { Trans } from '@lingui/react'
import classNames from 'clsx'
import { node, string } from 'prop-types'

const RedPointsBadge = props => {
  const classname = classNames(
    'a-Badge',
    `u-background-color--${props.color} a-RedpointsBadge--${props.size}`
  )

  if (props.children) {
    return (
      <div className={classname}>
        <div className="a-Badge__inner u-transform-center u-color--white u-text-align--center">
          <span className="a-Badge__label u-display--block">
            {props.children}
          </span>
          <span className="a-Badge__label a-Badge__label--smaller u-display--block">
            <Trans id={props.labelKey} />
          </span>
        </div>
      </div>
    )
  }
  return null
}

RedPointsBadge.propTypes = {
  children: node.isRequired,
  color: string,
  labelKey: string,
  size: string,
}

RedPointsBadge.defaultProps = {
  color: 'red',
  size: 'default',
  labelKey: /*i18n*/ 'general.label.redPoints',
}

export default RedPointsBadge
